import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-24 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <div className="relative rounded-2xl overflow-hidden mb-10">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20inviting%20modern%20workspace%20flat%20lay%20with%20laptop%20and%20organized%20shopping%20items%20on%20a%20soft%20cream%20background%2C%20minimal%20and%20clean%20composition%2C%20gentle%20film%20grain%20texture%2C%20natural%20soft%20lighting%2C%20elegant%20and%20aspirational%20aesthetic&width=1200&height=600&seq=cta-main-v9&orientation=landscape"
            alt="Start Using ItaobuySpreadsheet Today"
            title="ItaobuySpreadsheet – Get Started Now"
            className="w-full h-64 md:h-80 object-cover"
            loading="lazy"
          />
        </div>

        <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
          <span className="text-foreground-950">Start Using </span>
          <span className="text-primary-600">ItaobuySpreadsheet</span>
          <span className="text-foreground-950"> Today</span>
        </h2>
        <p className="mt-6 text-base md:text-lg text-foreground-600 max-w-xl mx-auto leading-relaxed">
          <span className="italic text-foreground-500">Simplify your shopping</span> with structured spreadsheets that help you{" "}
          <span className="italic text-foreground-500">save time instantly</span> and{" "}
          <span className="italic text-foreground-500">avoid unnecessary risks</span> — all in one organized platform.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 text-base font-semibold bg-foreground-950 text-background-50 rounded-full hover:bg-foreground-900 transition-all whitespace-nowrap cursor-pointer"
          >
            Start Using ItaobuySpreadsheet Now
          </a>
          <Link
            to="/itaobuyspreadsheet-guide"
            className="px-8 py-3.5 text-base font-semibold border-2 border-foreground-300 text-foreground-800 rounded-full hover:border-foreground-800 transition-all whitespace-nowrap cursor-pointer"
          >
            Read the Full Guide
          </Link>
        </div>
      </div>
    </section>
  );
}